import {  Ability, detectSubjectType } from '@casl/ability';
import jwtDecode from 'jwt-decode'
import settings from '../settings'

const permissionTokenName = settings.permissionTokenName;

const buildRules = () => {
    var permissions = [];
    if (localStorage.getItem(permissionTokenName)) {
        var permissionObj = jwtDecode(localStorage.getItem(permissionTokenName));

        permissions = JSON.parse(permissionObj.permissions).map(p => {
            var conditions = {}
            if (p.StatusId) {
                conditions.statusId = p.StatusId;
            }
            if (p.ServiceRequestTypes) {
                conditions.serviceRequestTypeId = {
                    $in: p.ServiceRequestTypes
                }
            }
            var permission = { action: p.Action, subject: p.Subject, conditions: conditions};
            if (p.Fields && p.Fields.length > 0) {
                permission = { action: p.Action, subject: p.Subject, conditions: conditions, fields: p.Fields};
            }
            return permission;
        })
    }

    return permissions
}
export { buildRules }

const getSubjectTypeName = (subject) => {
    if (subject && typeof subject === 'object' && subject.modelName) {
        return subject.modelName
    }

    return detectSubjectType(subject);
}

export default new Ability(buildRules(), {
    detectSubjectType: getSubjectTypeName
});